import { render, staticRenderFns } from "./TouchPad.vue?vue&type=template&id=1d653a50&scoped=true&"
import script from "./TouchPad.vue?vue&type=script&lang=js&"
export * from "./TouchPad.vue?vue&type=script&lang=js&"
import style0 from "./TouchPad.scss?vue&type=style&index=0&id=1d653a50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d653a50",
  null
  
)

export default component.exports